module.exports = __webpack_public_path__ + "img/approvals.544d4de6.svg";